import { Analyst } from '../../types/Analyst'
import { AnalystMutation, IntercomAdmin } from '../features/analysts/types/AnalystMutation'
import { internalCoreApi } from './internal'
import { internalApiserverApi } from './internal-apiserver'

const analystsApi = internalApiserverApi.enhanceEndpoints({ addTagTypes: ['internalAnalysts'] }).injectEndpoints({
  endpoints: (builder) => ({
    getInternalAnalysts: builder.query<Analyst[], void>({
      query: () => 'i/analysts/list',
      providesTags: ['internalAnalysts'],
    }),
    // Creates when `id` is null, updates otherwise.
    saveAnalyst: builder.mutation<Analyst, AnalystMutation>({
      query: (analyst) => ({ url: 'i/analysts', method: 'POST', body: analyst }),
      invalidatesTags: ['internalAnalysts'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          // Live Events Tracking reads analysts through its own slice.
          dispatch(internalCoreApi.util.invalidateTags(['analysts']))
        } catch {}
      },
    }),
    getIntercomAdmins: builder.query<IntercomAdmin[], void>({
      query: () => 'i/conversations/listIntercomAdmins',
    }),
  }),
})

export const { useGetInternalAnalystsQuery, useSaveAnalystMutation, useGetIntercomAdminsQuery } = analystsApi
